import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Delete } from "@mui/icons-material";
import { layoutStyle } from "../pages/layout-ui/style";
import { typeConstant } from "../common/constants/commonFunction";

export const FleetUploadConformDialog = ({
  open,
  close,
  handleClick,
  setOpen,
  handleClose,
  typeUser,
  dealerNameHeader,
}) => {
  const classes = layoutStyle();

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {typeUser === typeConstant.admin ? (
            "The uploaded fleet list dealer name does not match a valid dealer name. Are you sure you want to add a new dealer name?"
          ) : typeUser === typeConstant.dealer ? (
            <span className="font-size-16">
              Please keep dealer name column value as{" "}
              <span
                className="font-size-16"
                style={{
                  background: "rgb(38, 156, 47)",
                  padding: 5,
                  fontSize: "16px !important",
                  color: "white",
                }}
              >
                {`${dealerNameHeader?.dealerName}`}.
              </span>
              <br />
              If you have questions or need assistance, please contact:{" "}
              <span
                className="font-size-16"
                style={{
                  background: "yellow",
                  padding: 5,
                  fontSize: "16px !important",
                }}
              >
                cashflowsupport@onenexusgroup.com
              </span>
            </span>
          ) : (
            ""
          )}
        </DialogTitle>

        <DialogActions>
          <Button
            variant="outlined"
            type="submit"
            className={classes.deleteCancelButton}
            autoFocus
            onClick={handleClose}
          >
            Cancel
          </Button>
          {typeUser === typeConstant.admin && (
            <Button
              variant="outlined"
              type="submit"
              className={classes.deleteOkButton}
              onClick={handleClick}
            >
              Yes
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
